import { gql } from '@apollo/client';
import React, { useMemo } from 'react';
import { getActiveVariantBy } from '../../../../../lib/getActiveVariantBy';
import { ColorSelector, COLOR_SELECTOR_FRAGMENT } from '../../../../ColorSelector';
import { VariantCellColorSelectorFragment } from '../../../../../generated/types/VariantCellColorSelectorFragment';
import './VariantCellColorSelector.scss';

export const VARIANT_CELL_COLOR_SELECTOR = gql`
  fragment VariantCellColorSelectorFragment on Variant {
    ...ColorSelectorFragment
  }
  ${COLOR_SELECTOR_FRAGMENT}
`;

type Props = {
  variant: VariantCellColorSelectorFragment;
  activeVariantId: string;
  onSelectColor(color: string): void;
};

export const VariantCellColorSelector: React.FC<Props> = ({
  variant,
  onSelectColor,
  activeVariantId
}) => {
  const { color } = useMemo(() => getActiveVariantBy(variant, 'id', activeVariantId), [
    activeVariantId,
    variant
  ]);

  return (
    <div className="VariantCellColorSelector">
      <h4 className="VariantCellColorSelector__title">Select Color</h4>

      <ColorSelector
        size="small"
        className="VariantCellColorSelector__colors"
        variant={variant}
        onSelect={onSelectColor}
        selected={color}
      />
    </div>
  );
};
